import React from 'react';
import { useSignInWithGoogle, useSignInWithGithub } from 'react-firebase-hooks/auth';
import auth from '../../../firebase.init';
import google from '../../../images/google30.png';
import github from '../../../images/github30.png';
import { useNavigate } from 'react-router-dom';
import Loading from '../Loading/Loading';

const SocialAuth = () => {
    const [signInWithGoogle, googleUser, googleLoading, googleError] = useSignInWithGoogle(auth);
    const [signInWithGithub, githubUser, githubLoading, githubError] = useSignInWithGithub(auth);
    const navigate = useNavigate();

    if (googleUser || githubUser) {
        navigate('/home');
    }

    return (
        <div className='form-container p-0'>
            <div className='d-flex align-items-center justify-content-center'>
                <div style={{ height: '1px' }} className='bg-light bg-opacity-50 w-50'></div>
                <p className='mx-2 mt-2 text-light text-opacity-50'>or</p>
                <div style={{ height: '1px' }} className='bg-light bg-opacity-50 w-50'></div>
            </div>

            {
                (googleError || githubError) && <p className='text-danger text-center'>{googleError?.message} {githubError?.message}</p>
            }
            {
                (googleLoading || githubLoading) && <Loading></Loading>
            }

            <div className='row m-0'>
                <div className='col-sm-12 col-md-10 col-lg-8 col-xl-6 mx-auto'>
                    <button
                        onClick={() => signInWithGoogle()}
                        className='btn btn-outline-success w-100 d-block mx-auto my-2'>
                        <img src={google} alt="Google" />
                        <span className='px-2 text-light'>Sign In</span>
                    </button>
                </div>
                <div className='col-sm-12 col-md-10 col-lg-8 col-xl-6 mx-auto'>
                    <button
                        onClick={() => signInWithGithub()}
                        className='btn btn-outline-success w-100 d-block mx-auto my-2'>
                        <img src={github} alt="Github" />
                        <span className='px-2 text-light'>Sign In</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SocialAuth;